module.exports = __webpack_public_path__ + "static/confidence-d87c67436e05507adac78a78c111f599.gif";